import { useLocation, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4 pt-16">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <div className="w-16 h-16 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-5">
            <i className="ri-error-warning-line text-accent-600 text-2xl w-8 h-8 flex items-center justify-center"></i>
          </div>
          <h1 className="text-xl md:text-2xl font-bold text-foreground-900 mt-4 mb-2">
            Página não encontrada
          </h1>
          <p className="text-sm text-foreground-400 mb-1">
            O caminho <code className="text-xs bg-background-100 px-2 py-0.5 rounded text-foreground-600">{location.pathname}</code> não existe.
          </p>
          <p className="mt-4 text-sm text-foreground-500">
            Volte para a página inicial e continue explorando o CSSBuy Spreadsheet.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-white font-semibold text-sm rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line text-base w-4 h-4 flex items-center justify-center"></i>
            Voltar ao Início
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}